export function cycleValue(values, current) {
  if (values.length === 0) {
    throw new RangeError("cycleValue requires at least one value");
  }
  const index = current === void 0 ? -1 : values.indexOf(current);
  if (index === -1) {
    return values[0];
  }
  return values[(index + 1) % values.length];
}